import React from 'react';
import SpeakerNotesOutlinedIcon from '@mui/icons-material/SpeakerNotesOutlined';
import IconButton from '@mui/material/IconButton';
import { Link } from 'react-router-dom';
import Tooltip from '@mui/material/Tooltip';

export default ({ project: { id }, className }) => (
  <Link to={`/project-log?project=${id}`}>
    <Tooltip title="Audit trail">
      <IconButton aria-label="Audit trail" className={className}>
        <SpeakerNotesOutlinedIcon />
      </IconButton>
    </Tooltip>
  </Link>
);
